import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-other',
  templateUrl: './error-other.component.html',
  styleUrls: ['./error-other.component.scss']
})
export class ErrorOtherComponent {
  @Input() statusCode: number | null = null;
  private response: Response;
  private sourcePage: string | undefined = "";

  constructor(public helpersService: HelpersService,
              private router : Router,
              @Optional() @Inject(RESPONSE) response: any) { 
                this.response = response;
                this.sourcePage = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
              }

  ngOnInit(): void {
    this.helpersService.setDataLayerError(this.statusCode ?? 404, this.sourcePage);
    if (this.response) {
      this.response.status(this.statusCode ?? 404);
    }
  }
}
